export default function isForm404(location = {}) {
  if (location && location.href.includes('form404')) {
    return true;
  }

  return false;
}
